/* components/AccordionBody.ts

Accordion Body Component
sets the body height for when the accordion is open so animation is nice
*/

import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AccordionBody extends ThemeComponent {

    init() {
        const height = this.scrollHeight;
        this.style.height = height + 'px';
    }
}
